export default "__VITE_ASSET__BCF8h6Jx__"